import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Button from "../../../components/UI/button/GgButton";
import { Context } from "../../..";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import Spinner from "../../../components/UI/spinner/Spinner";
import HeaderBlock from "./blocks/HeaderBlock";
import LoanCustomer from "./blocks/LoanCustomer";
import { CBlock, GuideB, IBlocks, IContent, IHeader, IHeaderBlock, ILoanBlock, ILoanCBlock, } from "../../../models/IPages";
import GuideBlock from "./blocks/GuideBlock";
import {
  createFileFromBase64,
  getImageExtensionFromBase64,
  removeKeyFromObject,
} from "../../../utils";
import LoanBlock from "./blocks/LoanBlock";
import ContentBlock from "./blocks/ContentBlock";

const Team: FC = () => {
  const { pages, articles, store, roles } = useContext(Context);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const categoryType = window.location.pathname.split("/").pop() || "";

  const [guideBlock, setGuideBlock] = React.useState<GuideB>({
    image: "",
    heading: "",
    description: "",
    link: "",
    images: [],
  });

  const [contentBlock, setContentBlock] = React.useState<CBlock>({
    description: ""
  });

  // const [headerBlock, setHeaderBlock] = React.useState<IHeaderBlock>({
  //   title: "",
  //   subtitle: "",
  //   description:""
  // });

  const [loanBlock, setLoanBlock] = React.useState<ILoanBlock>({
    title: "",
    link: "",
    image:"",
    iRate:"",
    cRate:"",
    images:[]
  });

  const [loanCustomerBlock, setLoanCustomerBlock] = React.useState<ILoanCBlock>({
    title: "",
    description: "",
    image:"",
    images:[]
  });


  useEffect(() => {
    pages
      .loadList(categoryType)
      .then((res: any) => {
        handleFillData(res.content);
      })
      .catch(console.log);
    articles
      .loadList()
      .then((res: any) => {
        console.log(res);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    [
      // headerBlock,
      contentBlock,
      guideBlock,
      loanBlock,
      loanCustomerBlock,
     ].forEach((object, index) => {
      // remove base64 images from object
      const filteredObject = removeKeyFromObject(object, "images");
      // Convert object data to JSON string
      const objectData = JSON.stringify(filteredObject);
      const objectKey = Object.keys({
        // headerBlock,
        contentBlock,
        guideBlock,
        loanBlock,
        loanCustomerBlock,
      })[index];

      formData.append(objectKey, objectData);
      // Add images to the FormData
      if (object?.images && object.images.length > 0) {
        object.images.forEach((base64Image: string, imageIndex: number) => {
          if (base64Image) {
            let base64Data =
              base64Image?.split(",")?.[1] ||
              base64Image?.split(";base64,").pop() ||
              "";
            const ext = getImageExtensionFromBase64(base64Image);
            const image = createFileFromBase64(
              base64Data,
              `${objectKey}${imageIndex + 1}.${ext || "jpg"}`,
              `image/${ext || "jpg"}`
            );

            formData.append(`${objectKey}${imageIndex + 1}`, image);
          }
        });
      }
    });

    pages
      .updateOne(categoryType, formData)
      .then(() => {
        pages
          .loadList(categoryType)
          .then((res: any) => {
            handleFillData(res.content);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const handleFillData = (content: any) => {
    if (content) {
      // setHeaderBlock(content[0].headerBlock);
      setContentBlock(content[0].contentBlock)
      setGuideBlock(content[1].guideBlock);
      setLoanBlock(content[2].loanBlock)
      setLoanCustomerBlock(content[3].loanCustomerBlock)
    }
  };

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "pages")?.children?.find((child: any) => child.path === "team")
    setAdminPermissionData(userData)
  };
  

  return (
    <div className="team-page">
      {Object.keys(pages.pageContent).length > 0 &&
      !pages.loadingContentBool ? (
        <form className="body" onSubmit={handleSave}>
          <GuideBlock
            data={guideBlock}
            setData={setGuideBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />
          <ContentBlock
            data={contentBlock}
            setData={setContentBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />
          {/* <HeaderBlock
            data={headerBlock}
            setData={setHeaderBlock}
            categoryType={categoryType}
          /> */}
          <LoanBlock
            data={loanBlock}
            setData={setLoanBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />
          <LoanCustomer
              data={loanCustomerBlock}
              setData={setLoanCustomerBlock}
              categoryType={categoryType}
              actionData = {adminPermissionData}
            />
          <div className="btn-container">
            {adminPermissionData?.edit || adminPermissionData?.delete ? (
              <>
                <Button className="button" label="Save" type="submit" />
              </>
            ) : ""}
          </div>
        </form>
      ) : Object.keys(pages.pageContent).length === 0 &&
        !pages.loadingContentBool ? (
        <Emptiness icon={Timofey} content="It's time to create some content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default observer(Team);
